import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPaymentPredictDailyRow, IRequestModel, ISuccessFullPredictResponse } from '../models/models'

export class GetSuccessFullPredictApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/payment/GetSuccesPosPredict',
      requesterInfo,
    })
  }

  public async getSuccessFullPredict(req: IRequestModel): Promise<IPaymentPredictDailyRow[]> {
    return await this.postAsync<IPaymentPredictDailyRow[]>(req)
  }
}
